import Cookies from 'js-cookie'

export function cookies() {
  const $popup = $('.cookies-popup');
  const $button = $('.button-cookies');

  if (typeof Cookies.get('cookie-popup') === 'undefined') {
    $popup.slideDown(300);
  }

  $button.on('click', function () {
    $popup.slideUp(300);
    Cookies.set('cookie-popup', 1, { expires: 7, path: '/' });
  });

  const cookieButton = document.querySelector(".button-cookies");
  const cookieCheckbox = document.querySelector(".cookies-popup-checkbox");

  if (cookieButton && cookieCheckbox) {
    cookieCheckbox.addEventListener("change", function () {
      cookieButton.disabled = !cookieCheckbox.checked;
    });
  }
}
